import React from 'react';

export default function WelcomePhrase() {
  return (
    <div className="welcome-div">
      <h5>Bem vindo ao Rick And Memory Game!</h5>
      <p>Escolha a dificuldade e memorize a posição das cartas para vencer!</p>
    </div>
  );
};